const $$splitComponentImporter = () => import('/Users/vthang/projects/marvy_mono/apps/pinktool/src/routes/account/verify.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/account/verify")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});